/**
 * Shared responsive breakpoints.
 *
 * The values line up with the antd grid (`Row`/`Col` `xs`/`sm`/`md`/`lg` props) so that
 * layouts driven by the grid and layouts driven by these media queries switch at the
 * same widths.
 */
export const breakpoints = {
    /** Phones — up to and including this width. */
    phone: 767,
    /** Tablets — up to and including this width. */
    tablet: 1024,
};

export const media = {
    /** Phone only — 0…767px. */
    phone: `@media (max-width: ${breakpoints.phone}px)`,
    /** Tablet only — 768…1024px. */
    tablet: `@media (min-width: ${breakpoints.phone + 1}px) and (max-width: ${breakpoints.tablet}px)`,
    /** Phone and tablet — 0…1024px. */
    upToTablet: `@media (max-width: ${breakpoints.tablet}px)`,
};
